import {JSX} from "react";

import classNames from "classnames";

import {type LocationOption} from "@/features/locations";
import {ResponsiveSearchView} from "@/features/rental/simple-search/ui/responsive-search.view";

import "./styles/hero-search.scss";

type HeroSearchVariant = "default" | "alt";

interface HeroSearchProps {
    border?: 8 | 16;
    variant?: HeroSearchVariant;
    initialLocation?: LocationOption;
}

export function HeroSearch({border = 16, variant = "default", initialLocation}: HeroSearchProps): JSX.Element {
    return (
        <div
            className={classNames(
                "hero-search",
                {
                    "hero-search_border-8": border === 8,
                },
                `hero-search--${variant}`,
            )}
        >
            <ResponsiveSearchView initialLocation={initialLocation} />
        </div>
    );
}
